var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.486,
    height: 181.936,
    viewBox: "0 0 221.486 181.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#efefef;}.b{fill:none;stroke:#efefef;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-883.438 -263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(883.438 263)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 83.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.817,257.424a34.115,34.115,0,0,1-4.751-11.568,3.529,3.529,0,0,0-3.374-2.754H3.443A3.453,3.453,0,0,0,0,246.544v.069c0,.172.034.379.034.551A79.252,79.252,0,0,0,17.8,289.96a3.348,3.348,0,0,0,2.479,1.239h.172a3.556,3.556,0,0,0,2.445-1l28.473-28.473A3.391,3.391,0,0,0,51.817,257.424Z",
    transform: "translate(0 -243.101)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.57 106.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M125.221,316.1a34.217,34.217,0,0,1-11.362-4.682,3.443,3.443,0,0,0-4.338.448L81.082,340.34a3.429,3.429,0,0,0,0,4.855c.069.069.172.138.241.207a79.356,79.356,0,0,0,42.865,17.766,3.541,3.541,0,0,0,.585.034h.069a3.453,3.453,0,0,0,3.443-3.443V319.544A3.387,3.387,0,0,0,125.221,316.1Z",
    transform: "translate(-80.075 -310.85)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.664 0.186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M318.367,73.042a79.845,79.845,0,0,0-71.3-71.579,3.466,3.466,0,0,0-3.787,3.064v.31s-.069,10.088-.138,20.141c-.034,5.027-.069,10.088-.1,13.875,0,1.894-.034,3.477-.034,4.579v1.308c0,2.754,1.653,3.546,2.651,3.787h.069a33.037,33.037,0,0,1,25.512,25.547,3.4,3.4,0,0,0,3.374,2.686h40.352a3.328,3.328,0,0,0,3.409-3.718Z",
    transform: "translate(-243 -1.443)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.049 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.326.9a1.676,1.676,0,0,0-.413.034h-.138A80.039,80.039,0,0,0,.162,72.274a3.414,3.414,0,0,0,3.064,3.753,1.292,1.292,0,0,0,.344.034H43.853a3.461,3.461,0,0,0,3.374-2.72A33.547,33.547,0,0,1,72.808,48a3.464,3.464,0,0,0,2.754-3.374l.172-40.283A3.424,3.424,0,0,0,72.326.9ZM7.5,69.175c.31-2,.689-3.994,1.171-5.956l5.991,5.956Zm16.9,0L10.938,55.713a62.778,62.778,0,0,1,2.892-6.852L34.109,69.175H24.4Zm17.456-2.031L17.239,42.561c1.205-2,2.513-3.925,3.925-5.819L44.92,60.5A37.386,37.386,0,0,0,41.856,67.144Zm9.537-15.011c-.861.861-1.653,1.721-2.445,2.651L25.605,31.44c.792-.9,1.618-1.756,2.479-2.617q1.136-1.188,2.376-2.272L53.8,49.894C52.977,50.618,52.151,51.341,51.393,52.132Zm8.091-6.266L35.762,22.144a65.651,65.651,0,0,1,5.784-3.925L66.129,42.768A40.153,40.153,0,0,0,59.484,45.866Zm9.227-10.26L47.847,14.742A70.361,70.361,0,0,1,54.7,11.85L68.746,25.9Zm.069-19.418L62.17,9.577a62.932,62.932,0,0,1,6.645-1.308Z",
    transform: "translate(-0.142 -0.901)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(962.97 375.043)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M138.511,260.369h-8.986V200.634a3.431,3.431,0,0,0-3.581-3.271h-21.9a3.28,3.28,0,0,0-3.409,3.271v59.736H85.489V211.617a3.609,3.609,0,0,0-3.512-3.581H60.08a3.657,3.657,0,0,0-3.512,3.581v48.752H41.419V226.284a3.424,3.424,0,0,0-3.409-3.443H16.044a3.574,3.574,0,0,0-3.581,3.443v34.085H3.443a3.443,3.443,0,1,0,0,6.886H138.511a3.443,3.443,0,1,0,0-6.886Zm-104.012,0h0Zm44.07,0h0Zm44.07,0h0Z",
    transform: "translate(0 -197.363)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1189.737,682.759l88.58-24.86",
    transform: "translate(2179.309 -306.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(980 367)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1025 354)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1069 343)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.b097057e0124df5ef76faa4d5d2efa45.svg";
export { ForwardRef as ReactComponent };